import { DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useCohortsDataGridFetch } from '../../hooks/useCohortsDataGridFetch';
import { useCohortsListPageContent } from '../../hooks/useCohortsListPageContent';

export const CohortsListPageContent = () => {
  const { columnDefinition, onCohortCellClick, messages } = useCohortsListPageContent();

  return (
    <DataGridLayout id="cohorts-datagrid-layout">
      <DataGrid
        id="cohort-list"
        mode="client"
        getRowId={(row) => row.cohortProfileId}
        columns={columnDefinition}
        useFetchDataGridData={useCohortsDataGridFetch}
        messages={messages}
        pageSizeOptions={[1, 5, 10, 25, 50, 100]}
        onCellClick={onCohortCellClick}
        initialState={{
          sorting: {
            sortModel: [{ field: 'modifiedBy.transactionDate', sort: 'desc' }],
          },
        }}
      />
    </DataGridLayout>
  );
};
